export default {
  SET_INCOMPLETE_CAMPAIGN_LIST(state, incompleteCampaignList) {
    state.incompleteCampaignList = incompleteCampaignList
  },
  SET_INCOMPLETE_CAMPAIGN_COUNT(state, incompleteCampaignCount) {
    state.incompleteCampaignCount = incompleteCampaignCount
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}
